import { $axios } from '@/modules/http/axios'
import Swal from 'sweetalert2'

async function reportFailedStoppagesUpdate (task, failedStoppages) {
  await Swal.fire(
    `Nie udało się zaktualizować wszystkich postojów dla zlecenia ${task.numer_Przejazdu}`,
    `Nie udało się dodać postoju: ${failedStoppages[0].acronym}. Proszę ponownie zaktualizować godzinę.`,
    'error'
  )
}

export async function updateTaskLoadingDate(task, date) {
  const taskStoppages = task.stoppages
  const failedStoppages = []

  taskStoppages.map(async (stoppage, stoppageIndex) => {
    try {
      await $axios.put(`Stoppages/${stoppage.id}`, {
        acronym: stoppage.acronym,
        arrival: stoppageIndex === 0 ? date : stoppage.arrival,
        departure: stoppage.departure,
        backgroundColor: stoppage.backgroundColor
      })
    } catch (e) {
      failedStoppages.push(stoppage)
    }
  })

  if (failedStoppages.length) {
    await reportFailedStoppagesUpdate(task, failedStoppages)
  } else {
    await Swal.fire(`Zaktualizowano godzinę załadunku dla zlecenia: ${task.numer_Przejazdu}`, '', 'success')
  }
}

export async function updateTaskUnloadingDate(task, date) {
  const taskStoppages = task.stoppages
  const failedStoppages = []

  taskStoppages.map(async (stoppage, stoppageIndex) => {
    try {
      await $axios.put(`Stoppages/${stoppage.id}`, {
        acronym: stoppage.acronym,
        arrival: stoppageIndex === (taskStoppages.length - 1) ? date : stoppage.arrival,
        departure: stoppageIndex === (taskStoppages.length - 1) ? date : stoppage.departure,
        backgroundColor: stoppage.backgroundColor
      })
    } catch (e) {
      failedStoppages.push(stoppage)
    }
  })

  if (failedStoppages.length) {
    await reportFailedStoppagesUpdate(task, failedStoppages)
  } else {
    await Swal.fire(`Zaktualizowano godzinę rozładunku dla zlecenia: ${task.numer_Przejazdu}`, '', 'success')
  }
}
